import type { ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';

export interface ExpenseRowProps {
  icon: LucideIcon;
  iconColor?: string;
  title: string;
  sub: string;
  amount: string;
  split?: string;
  footer?: ReactNode;
}

export function ExpenseRow({
  icon: Icon,
  iconColor = '#018B9C',
  title,
  sub,
  amount,
  split,
  footer,
}: ExpenseRowProps) {
  return (
    <div className='mk-expense'>
      <span className='mk-expense__icon' style={{ background: iconColor }}>
        <Icon size={20} strokeWidth={2.2} />
      </span>
      <div className='mk-expense__body'>
        <p className='mk-expense__title'>{title}</p>
        <p className='mk-expense__sub'>{sub}</p>
      </div>
      <div className='mk-expense__amount'>
        <p className='mk-expense__value'>{amount}</p>
        {split ? <p className='mk-expense__split'>{split}</p> : null}
        {footer}
      </div>
    </div>
  );
}
